import { ValidationErrorMessage } from 'react-admin';

const UID_REGEX = /^[a-zA-Z0-9_-]{8,}$/;
const VIDEO_DELIVERY_REGEX = /(?:iframe\.)?videodelivery\.net\/[a-zA-Z0-9_-]{8,}/;
const VIDEO_DELIVERY_CAPTURE_REGEX = /(?:iframe\.)?videodelivery\.net\/([a-zA-Z0-9_-]{8,})/;

export const normalizeCfStreamUid = (value?: string): string => {
    if (!value) return '';
    const trimmed = value.trim();
    if (!trimmed) return '';
    const fromUrl = trimmed.match(VIDEO_DELIVERY_CAPTURE_REGEX)?.[1];
    return fromUrl || trimmed;
};

export const isCfStreamUid = (value?: string): boolean => {
    const normalized = normalizeCfStreamUid(value);
    return UID_REGEX.test(normalized);
};

export const validateCfStreamUid = (
    value?: string
): ValidationErrorMessage | undefined => {
    if (!value) {
        return 'UID is required';
    }

    const normalized = value.trim();
    if (!normalized) {
        return 'UID is required';
    }

    if (!UID_REGEX.test(normalized) && !VIDEO_DELIVERY_REGEX.test(normalized)) {
        return 'Please enter a valid CF Stream UID or videodelivery.net URL';
    }

    return undefined;
};
